import { render, staticRenderFns } from "./GenerateJigModal.vue?vue&type=template&id=5c80e104"
import script from "./GenerateJigModal.vue?vue&type=script&lang=ts"
export * from "./GenerateJigModal.vue?vue&type=script&lang=ts"
import style0 from "./GenerateJigModal.vue?vue&type=style&index=0&id=5c80e104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports